export default class ErrorPageView {
  constructor({ errorTitle, errorMessage, value }) {
    this.errorTitle = errorTitle;
    this.errorMessage = errorMessage;
    this.value = value;
  }
}
